import { getUITranslation } from "../utils/get_ui_translation";
import { create as createIcon } from "../framework/components/icon";
import { urlBadgeTemplate, circleChartTemplate } from "../framework/tabulars";

export const SIGNED = "signed";
export const ELECTRONICALY_SIGNED = "electronicaly_signed";
export const VIEWED = "viewed";
export const CHECKED = "checked";
export const NEED_TO_SIGN = "need_to_sign";
export const ABANDON = "abandon";
export const ABSENCE = "absence";
export const ABSENCE_JUSTIFIED = "absence_justified";
export const ILLNESS = "illness";
export const OTHER = "other";
export const NEED_TO_SIGN_FUTURE = "need_to_sign_future";
export const MIXT = "attendance_and_absence";
export const ATTENDANCE_SCHEDULED = "attendance_scheduled";
export const SENT_INVITE = "sent_invite";
export const PROCESSING = "processing";
export const REFUSED_TO_SIGN = "refused_to_sign";

export const groupCell = (container, options) => {
  const cell = document.createElement("div");
  cell.setAttribute("class", "dx-datagrid-group-text-content");
  cell.textContent = options.text;
  container.appendChild(cell);
};

export const signatureCell = (container, options) => {
  const text = JSON.parse(window.attendance_table_locales)[options.value] ?? options.value;
  let textClass = "";
  let icon;
  switch (options.value) {
    case MIXT:
      icon = "bug";
      textClass = "has-text-purple-100";
      break;
    case ABANDON:
      icon = "user--absent--cross";
      break;
    case ABSENCE:
      icon = "user--absent";
      break;
    case ABSENCE_JUSTIFIED:
      icon = "user--absent--check";
      break;
    case ILLNESS:
      icon = "user--absent--info";
      break;
    case OTHER:
      icon = "user--absent--minus";
      break;
    case SIGNED:
      icon = "pen--alt";
      break;
    case ELECTRONICALY_SIGNED:
      icon = "pen--fountain--writing";
      break;
    case PROCESSING:
      icon = "mail";
      break;
    case CHECKED:
      icon = "checkbox--checked";
      break;
    case VIEWED:
      icon = "video";
      break;
    case NEED_TO_SIGN_FUTURE:
      icon = "calendar--blank";
      break;
    case ATTENDANCE_SCHEDULED:
      icon = "bulb";
      break;
    case SENT_INVITE:
      icon = "checkbox--checked";
      break;
    case REFUSED_TO_SIGN:
      icon = "exclamation--triangle--filled";
      break;
    default:
      icon = "exclamation--circle--filled";
      textClass = "has-text-purple-100";
      break;
  }

  const iconEl = createIcon(icon);
  iconEl.setAttribute("role", "img");

  const textDiv = document.createElement("div");
  textDiv.innerText = text;

  const htmlState = document.createElement("div");
  htmlState.classList.add("line", "line--compact");
  if (textClass) {
    htmlState.classList.add(textClass);
  }
  htmlState.appendChild(iconEl);
  htmlState.appendChild(textDiv);

  let containerHtmlState;
  if ([NEED_TO_SIGN, MIXT, ABSENCE, CHECKED].find((e) => e == options.value)) {
    const anchor = document.createElement("a");
    anchor.classList.add("anchor");
    anchor.setAttribute("href", p`/training_sessions/${options.data.ts_id}/attendance/manual_sign`);
    anchor.appendChild(htmlState);
    containerHtmlState = anchor;
  } else {
    containerHtmlState = htmlState;
  }

  container.appendChild(containerHtmlState);
};

const createAddButton = (onClick) => {
  const button = document.createElement("button");
  button.classList.add("button", "button--secondary", "button--sm", "has-px-01", "has-mr-02");
  button.appendChild(createIcon("plus"));

  if (onClick) {
    button.addEventListener("click", (e) => {
      e.stopPropagation();
      onClick();
    });
  }

  return button;
};

const createEmptyStateLink = (url, emptyText) => {
  const link = document.createElement("a");
  link.classList.add("abandon-badges-wrapper");
  link.setAttribute("href", url);

  const textSpan = document.createElement("span");
  textSpan.innerText = getUITranslation(emptyText);

  link.appendChild(createAddButton());
  link.appendChild(textSpan);

  return link;
};

const createBadgeWithCount = (container, count, label, colorClass) => {
  if (count <= 0) return;

  const countSpan = document.createElement("span");
  countSpan.classList.add("abandon-badge-count");
  countSpan.textContent = count;

  urlBadgeTemplate(container, label, colorClass, "xs", {}, countSpan);
};

const createBadge = (container, label, colorClass) => {
  urlBadgeTemplate(container, label, colorClass, "xs", {});
};

const createBadgesWrapper = (url, badgesConfig) => {
  const wrapper = document.createElement("div");
  wrapper.classList.add("abandon-badges-wrapper");

  const badgesContainer = document.createElement("div");
  badgesContainer.classList.add("abandon-badges-list");

  badgesConfig.forEach(({ count, label, colorClass, showCount = true }) => {
    if (showCount) {
      createBadgeWithCount(badgesContainer, count, label, colorClass);
    } else if (count > 0) {
      createBadge(badgesContainer, label, colorClass);
    }
  });

  const button = createAddButton(() => {
    window.location.href = url;
  });

  wrapper.appendChild(button);
  wrapper.appendChild(badgesContainer);

  return wrapper;
};

const badgesCellTemplate = (container, options, config) => {
  const { urlBuilder, emptyText, badgesConfig } = config;
  const url = urlBuilder(options.data);
  const isEmpty = options.value.total === 0;

  if (isEmpty) {
    container.appendChild(createEmptyStateLink(url, emptyText));
  } else {
    const badges = badgesConfig(options.value);
    container.appendChild(createBadgesWrapper(url, badges));
  }
};

export const partialAbsenceBadgesCell = (container, options) => {
  badgesCellTemplate(container, options, {
    urlBuilder: (data) => p`/training_sessions/${data.ts_id}/partial_absences/tts/${data.tts_id}/new`,
    emptyText: getUITranslation("Aucun retard"),
    badgesConfig: (value) => [
      { count: value.early_departure, label: getUITranslation("Départ anticipé"), colorClass: "color-badge-early-departure" },
      { count: value.delay, label: getUITranslation("Retard"), colorClass: "color-badge-delay" },
    ],
  });
};

export function absencePercentageCell(container, options) {
  circleChartTemplate(container, {
    in_progress: options.data.info_absences.percentage_absence,
    total: options.data.info_absences.percentage_absence_allowed,
    text:
      options.data.info_absences.duration_hours_absence_formated +
      "(" +
      options.data.info_absences.percentage_absence +
      "%" +
      "/" +
      options.data.info_absences.percentage_absence_allowed +
      "%)",
    color_filled: "#46c161",
    color_to_filled: "#f1c1c1",
  });
}

export const abandonBadgesCell = (container, options) => {
  badgesCellTemplate(container, options, {
    urlBuilder: (data) => p`/training_sessions/${data.ts_id}/abandons/tts/${data.tts_id}/new`,
    emptyText: getUITranslation("Aucune absence"),
    badgesConfig: (value) => [
      { count: value.justified_absences, label: getUITranslation("Absence justifiée"), colorClass: "color-badge-justified" },
      { count: value.unjustified_absences, label: getUITranslation("Absence injustifiée"), colorClass: "color-badge-unjustified" },
      { count: value.other, label: getUITranslation("Autre"), colorClass: "color-badge-unjustified" },
      { count: value.illness, label: getUITranslation("Maladie"), colorClass: "color-badge-justified" },
      { count: value.abandons, label: getUITranslation("Abandon"), colorClass: "color-badge-abandon", showCount: false },
    ],
  });
};

export const electronicSignatureCell = (container, options) => {
  let text = JSON.parse(window.attendance_table_locales)[options.value] ?? options.value;
  let icon;
  switch (options.value) {
    case MIXT:
      icon = "bug";
      break;
    case ABANDON:
      icon = "user--absent--cross";
      break;
    case ABSENCE:
      icon = "user--absent";
      break;
    case ABSENCE_JUSTIFIED:
      icon = "user--absent--check";
      break;
    case ILLNESS:
      icon = "user--absent--info";
      break;
    case OTHER:
      icon = "user--absent--minus";
      break;
    case SIGNED:
      icon = "pen--alt";
      break;
    case ELECTRONICALY_SIGNED:
      icon = "pen--alt";
      break;
    case PROCESSING:
      icon = "mail";
      break;
    case CHECKED:
      icon = "checkbox--checked";
      break;
    case VIEWED:
      icon = "video";
      break;
    case NEED_TO_SIGN_FUTURE:
      icon = "calendar--blank";
      break;
    case REFUSED_TO_SIGN:
      icon = "exclamation--triangle--filled";
      break;
    case SENT_INVITE:
      icon = "checkbox--checked";
      break;
    case NEED_TO_SIGN:
    default:
      icon = "exclamation--circle--filled";
      break;
  }

  if (options.data.email == "" || options.data.email == null) {
    text = getUITranslation("Émargement électronique impossible - Aucune adresse email renseignée");
    icon = "exclamation--circle--filled";
  }
  const iconEl = createIcon(icon);
  const htmlState = document.createElement("div");
  htmlState.classList.add("line", "line--compact");
  const textEl = document.createElement("span");
  textEl.innerText = text;
  htmlState.appendChild(iconEl);
  htmlState.appendChild(textEl);

  let containerHtmlState;
  if ([NEED_TO_SIGN, MIXT].find((e) => e == options.value)) {
    let anchorEl = document.createElement("a");
    anchorEl.classList.add("anchor");
    anchorEl.setAttribute("href", p`/training_sessions/${options.data.ts_id}/attendance/manual_sign`);
    anchorEl.appendChild(htmlState);
    containerHtmlState = anchorEl;
  } else {
    containerHtmlState = htmlState;
  }

  container.appendChild(containerHtmlState);
};

export const nameCell = (container, options) => {
  let icon = "";
  if (options.data.attendee_type === "instructor") {
    icon = "user--teacher";
  } else {
    icon = "student";
  }

  const iconEl = createIcon(icon);
  const dataEl = document.createElement("div");
  dataEl.innerText = options.data.name;

  const html = document.createElement("div");
  html.classList.add("line", "line--compact");
  html.appendChild(iconEl);
  html.appendChild(dataEl);

  container.appendChild(html);
  container.classList.add("name-cell");
};

export const signatureCellText = (cellInfo) => {
  return JSON.parse(window.attendance_table_locales)[cellInfo.value] ?? cellInfo.value;
};

export const abandonCellText = (cellInfo) => {
  return JSON.parse(window.abandon_table_locales)[cellInfo.value] ?? cellInfo.value;
};

export const colorInstructorRow = (e) => {
  if (e.rowType == "data" && e.data.id.includes("instructor")) {
    e.cellElement.className += " instructor-row";
  }
};
